import { render, staticRenderFns } from "./ConfiguredOptionsTable.vue?vue&type=template&id=464956c6&scoped=true&"
import script from "./ConfiguredOptionsTable.vue?vue&type=script&lang=js&"
export * from "./ConfiguredOptionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464956c6",
  null
  
)

export default component.exports